import dayjs from 'dayjs'

// Tên Việt: Họ + [tên đệm] + Tên - monogram/avatar nên lấy chữ cái đầu của TỪ CUỐI (tên, given
// name) chứ không phải từ đầu (họ, family name) - "Lê Thị Ái Nhân" -> "N", không phải "L". Dùng
// chung cho mọi avatar chữ cái trong feature Family Book (DedupedMemberRow, MyMemberCard,
// MyProfileCard, MemberRow...) thay vì mỗi nơi tự viết `.charAt(0)` (sai cho tên Việt).
export const getGivenNameInitial = (name) => {
    if (!name) return '?'
    const parts = String(name).trim().split(/\s+/)
    const last = parts[parts.length - 1]
    return last ? last.charAt(0).toUpperCase() : '?'
}

// Tuổi hiện tại (còn sống) hoặc tuổi lúc mất (đã mất - tính đến death_date, không phải hôm nay) -
// 1 công thức dùng chung thay vì mỗi nơi tự `dayjs().diff(...)` riêng (dễ quên trừ theo death_date).
export const computeAge = (birthDate, deathDate) => {
    if (!birthDate) return null
    const end = deathDate ? dayjs(deathDate) : dayjs()
    return end.diff(dayjs(birthDate), 'year')
}
